import { Box, Spinner } from '@timelyapp/react';
import React, { lazy, Suspense } from 'react';
import { useSelector } from 'react-redux';
import { getIsDayLockedByDate } from 'redux/modules/dayProperties.selectors';
import { getMemorySidebarProps } from 'redux/selectors/timeline.memories';
import { getTicMemoryViewmode } from 'redux/selectors/user';
import MemoryTimelineSubscriptionPrompt from '../../memory/MemoryTimelineSubscriptionPrompt';
import { TicMemoryHeader } from './TicMemoryHeader';
import styles from './TicMemorySidebar.module.scss';

const TicMemoryTimelineDropzone = lazy(() => import('~domains/memory/components/Memory.Dropzone'));

const TicMemoryTimeline = lazy(() => import('./TicMemoryTimeline'));
const TicMemoryListContainer = lazy(() => import('../memory-list/TicMemoryListContainer'));

interface Props {
  date: string;
  /** Indicates if MemorySidebar is inlined, needed to position Zoom controls */
  inline?: boolean;
  className?: string;
}

const TicMemorySidebar: React.FC<Props> = ({ date }) => {
  const { ui } = useSelector(getMemorySidebarProps);
  const isDayLocked = useSelector(state => getIsDayLockedByDate(state, date));
  const viewMode = useSelector(getTicMemoryViewmode);

  const SuspenseFallback = (
    <Box.Column
      height="100%"
      flexGrow={1}
      overflow="hidden"
      alignItems="center"
      justifyContent="center"
    >
      <Spinner />
    </Box.Column>
  );

  return (
    <Box.Column className={styles.memoriesContainer}>
      {ui.isSubscriptionExpiredOrTrialEnded && <MemoryTimelineSubscriptionPrompt />}
      <TicMemoryHeader date={date} />
      {viewMode === 'list' ? (
        <Suspense fallback={SuspenseFallback}>
          <TicMemoryListContainer disabled={ui.isDisabled || isDayLocked} />
        </Suspense>
      ) : (
        <Suspense fallback={SuspenseFallback}>
          <TicMemoryTimelineDropzone>
            <TicMemoryTimeline disabled={ui.isDisabled || isDayLocked} />
          </TicMemoryTimelineDropzone>
        </Suspense>
      )}
    </Box.Column>
  );
};
TicMemorySidebar.displayName = 'TicMemorySidebar';
export default TicMemorySidebar;
